import React from "react";
import toastError from "../../errors/toastError";

const LocationPreview = ({ image, link, description }) => {
  const handleLocation = async () => {
    try {
      window.open(link);
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <div className="min-w-[250px] bg-white dark:bg-dark-800 rounded-lg overflow-hidden">
      <div className="flex items-start gap-3 p-2">
        {/* Map thumbnail */}
        <img
          src={image}
          onClick={handleLocation}
          className="w-24 h-auto rounded cursor-pointer hover:opacity-80 transition-opacity"
          alt="Location"
        />

        {/* Description */}
        {description && (
          <div className="flex-1 py-2">
            <p
              className="text-sm text-primary-600 dark:text-primary-400"
              dangerouslySetInnerHTML={{
                __html: description.replace("\\n", "<br />"),
              }}
            />
          </div>
        )}
      </div>

      {/* Divider and button */}
      <div className="border-t border-dark-200 dark:border-dark-700">
        <button
          onClick={handleLocation}
          disabled={!link}
          className="w-full py-2 text-sm font-medium text-primary-600 dark:text-primary-400 hover:bg-dark-50 dark:hover:bg-dark-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Visualizar
        </button>
      </div>
    </div>
  );
};

export default LocationPreview;
